import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import TopLeftMenu from '../../components/doctors/partials/topLeftMenu';
import Header from '../../components/doctors/partials/Header';
import {
  getRequest,
  postRequest,
  deleteRequest,
} from '../../utils/axiosRequests';
import { deleteConfirmation } from '../../utils/helpers';
import { toast } from 'react-toastify';
import moment from 'moment';
import md5 from 'md5';
import { usePostRequest } from '../../hooks/usePostRequest';
import { useSelector } from 'react-redux';
import { useGetRequest } from '../../hooks/useGetRequest';
import { usePatchRequest } from '../../hooks/usePatchRequest';
import { useDeleteRequest } from '../../hooks/useDeleteRequest';

function AnnouncePage() {
  const [announces, setAnnounces] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [content, setContent] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);
  const [generatedToken, setGeneratedToken] = useState('');
  const [generatedLink, setGeneratedLink] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);

  const userInfo = useSelector((state) => state.authReducer.data);

  const activeDoctor = useSelector(
    (state) => state.doctorsOfAssistantReducer.activeDoctor,
  );

  const activeOrganization = useSelector(
    (state) => state.orgReducer.organization,
  );

  // const fetchAnnounces = () => {
  //   setIsLoading(true);
  //   getRequest('announces')
  //     .then((data) => {
  //       setAnnounces(data || []);
  //       setIsLoading(false);
  //     })
  //     .catch(() => {
  //       setIsLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   fetchAnnounces();
  // }, []);

  const { isLoading: isLoadingCreatingAnnounce, mutate: submitCreateAnnounce } =
    usePostRequest(
      'live-announces',
      {
        doctorId:
          userInfo?.userType === 'assistant' ? activeDoctor?.id : userInfo.id,
        title: content,
      },
      (res) => {
        toast.success('Announcement created', {
          position: toast.POSITION.TOP_RIGHT,
        });
        setContent('');
        getAnnounces();
      },
      (e) => {
        toast.error(e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
    );

  const getUrl =
    userInfo?.userType === 'doctor'
      ? `live-announces`
      : `live-announces?doctorId=${activeDoctor.id}`;

  const { isLoading: isAnnounceLoading, refetch: getAnnounces } = useGetRequest(
    'get-announces',
    getUrl,
    (data) => {
      setAnnounces(data);
    },
    (e) => {
      console.log(e);
    },
  );

  useEffect(() => {
    getAnnounces();
  }, []);

  const getUpdatUrl =
    userInfo?.userType === 'doctor'
      ? `live-announces/${selectedId}`
      : `live-announces/${selectedId}?doctorId=${activeDoctor.id}`;

  const { isLoading: isLoadingUpdateAnnounce, mutate: updateAnnounce } =
    usePatchRequest(
      getUpdatUrl,
      {
        status: 'on',
      },
      (res) => {
        toast.success('Announcement choosed succesfully', {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
      (e) => {
        toast.error(e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
    );

  const getAllUpdateUrl =
    userInfo?.userType === 'doctor'
      ? `live-announces/stop-announce`
      : `live-announces/stop-announce?doctorId=${activeDoctor.id}`;

  // const { isLoading: isLoadingUpdateAnnounces, refetch: stopAnnounce } =
  //   useGetRequest(
  //     getAllUpdateUrl,
  //     (res) => {
  //       toast.success('Announcement stopped succesfully', {
  //         position: toast.POSITION.TOP_RIGHT,
  //       });
  //     },
  //     (e) => {
  //       toast.error(e.message, {
  //         position: toast.POSITION.TOP_RIGHT,
  //       });
  //     },
  //   );

  const { isLoading: isStoppingAnnounce, refetch: stopAnnounce } =
    useGetRequest(
      'stop-announces',
      getAllUpdateUrl,
      (data) => {
        toast.success('Announcement stopped succesfully', {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
      (e) => {
        console.log(e);
      },
    );

  const { isLoading: isAnnounceDeleteLoading, mutate: deleteAnnounce } =
    useDeleteRequest(
      `live-announces/${selectedId}`,
      () => {
        toast.success('Announce Removed', {
          position: toast.POSITION.TOP_RIGHT,
        });
        setSelectedId('');
        setShowConfirm(false);
        getAnnounces();
      },
      (e) => {
        toast.error(e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
    );

  const handleGenerateLink = () => {
    const doctorId =
      userInfo?.userType === 'assistant' ? activeDoctor?.id : userInfo?.id;
    const organizationId =
      userInfo?.userType === 'assistant'
        ? userInfo?.organizationIds?.[0]
        : activeOrganization?.id || '';
    const token = Math.floor(10000000 + Math.random() * 90000000).toString();
    const userToken = md5(`${doctorId}${moment().format('YYYY-MM-DD')}`);
    const base = window.location.origin;
    const link = `${base}/show-appointments?doctorId=${doctorId}&organizationId=${organizationId}&userToken=${userToken}`;
    const expiresAt = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString();

    setIsGenerating(true);
    postRequest('live-announces/generate-serial-token', {
      token,
      doctorId,
      organizationId,
      link,
      expiresAt,
    })
      .then(() => {
        setGeneratedToken(token);
        setGeneratedLink(link);
      })
      .catch(() => {
        toast.error('Failed to generate link. Please try again.', {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => setIsGenerating(false));
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success('Copied to clipboard!', {
        position: toast.POSITION.TOP_RIGHT,
      });
    });
  };

  const handleCreate = (e) => {
    e.preventDefault();
    if (!content.trim()) {
      toast.error('Description required');
      return;
    }
    submitCreateAnnounce();
  };

  const handleSelect = (e) => {
    e.preventDefault();
    if (!selectedId) {
      toast.error('Please select an announcement');
      return;
    }
    updateAnnounce();
  };

  const selectedAnnounce = announces.find((a) => a._id === selectedId);

  const handleClose = () => {
    setShowConfirm(false);
  };

  const handleYes = () => {
    deleteAnnounce();
  };

  const handleDeleteButton = (e) => {
    e.preventDefault();
    if (!selectedId) {
      toast.error('Please select an announcement');
      return;
    }
    setShowConfirm(true);
  };

  return (
    <div>
      <Header />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-md-12 sticky-header shadow header-sticky-second">
            <TopLeftMenu />
          </div>
        </div>
        <Row className="rx-body">
          <div className="col-xl-12 col-md-12 col-lg-12">
            <div className="common-page-content">
              {/* Generate Appointment Page Link */}
              <div className="card mb-4 mt-4 shadow-sm">
                <div className="card-header font-weight-bold">
                  Generate Appointment Page Link
                </div>
                <div className="card-body m-4">
                  <p className="text-muted mb-3">
                    Generate a unique 8-digit token that can used at{' '}
                    <strong>/patient-serial</strong> to access today's
                    appointment page. The token expires after 24 hours.
                  </p>
                  <Button
                    variant="primary"
                    size="sm"
                    disabled={isGenerating}
                    onClick={handleGenerateLink}
                  >
                    {isGenerating
                      ? 'Generating...'
                      : 'Generate Appointment Page Link'}
                  </Button>
                  {generatedToken && (
                    <div
                      className="mt-3 p-3 rounded"
                      style={{
                        background: '#f0f8ff',
                        border: '1px solid #cce5ff',
                      }}
                    >
                      <div className="mb-2 d-flex align-items-center flex-wrap gap-2">
                        <strong>8-Digit Token:</strong>
                        <span
                          className="badge bg-primary"
                          style={{
                            fontSize: '1.1rem',
                            letterSpacing: '4px',
                            padding: '6px 14px',
                          }}
                        >
                          {generatedToken}
                        </span>
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          onClick={() => copyToClipboard(generatedToken)}
                        >
                          Copy Token
                        </Button>
                      </div>
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        <strong>Appointment Link:</strong>
                        <span
                          className="text-muted small"
                          style={{ wordBreak: 'break-all' }}
                        >
                          {generatedLink}
                        </span>
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          onClick={() => copyToClipboard(generatedLink)}
                        >
                          Copy Link
                        </Button>
                      </div>
                      <p className="mb-0 mt-2 text-muted small">
                        On <strong>/patient-serial </strong>
                        enter this token to access the appointment page. Valid
                        for 24 hours.
                      </p>
                    </div>
                  )}
                </div>
              </div>

              {/* Select an announcement */}
              <div className="card mb-4 shadow-sm">
                <div className="card-header font-weight-bold">
                  Select Announcement
                </div>
                <div className="card-body mb-4 pt-3">
                  <Form onSubmit={handleSelect}>
                    <Form.Group as={Row} className="m-2 align-items-center">
                      <Form.Label column sm={2} className="label-bold">
                        Choose Announcement
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          as="select"
                          value={selectedId}
                          onChange={(e) => setSelectedId(e.target.value)}
                          size="sm"
                        >
                          <option value="">-- Select an announcement --</option>
                          {announces.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.title}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Form.Group>
                    <Row>
                      <Col sm={{ span: 8, offset: 2 }}>
                        <Button
                          type="submit"
                          variant="primary"
                          size="sm"
                          disabled={isLoadingUpdateAnnounce}
                          style={{ marginRight: '10px', marginLeft: '12px' }}
                        >
                          {isLoadingUpdateAnnounce
                            ? 'Saving...'
                            : 'Select Announcement'}
                        </Button>
                        <Button
                          variant="primary"
                          size="sm"
                          disabled={isStoppingAnnounce}
                          onClick={(e) => stopAnnounce()}
                        >
                          {isStoppingAnnounce
                            ? 'Saving...'
                            : 'Stop Announcement'}
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          disabled={isAnnounceDeleteLoading}
                          style={{ marginLeft: '10px' }}
                          onClick={(e) => handleDeleteButton(e)}
                        >
                          {isAnnounceDeleteLoading
                            ? 'Saving...'
                            : 'Delete Announcement'}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                  {/* {selectedAnnounce && (
                    <div
                      className="mt-3 p-3 rounded"
                      style={{
                        background: '#f0f8ff',
                        border: '1px solid #cce5ff',
                      }}
                    >
                      <strong>{selectedAnnounce.title}</strong>
                      <p
                        className="mb-0 mt-1"
                        style={{ whiteSpace: 'pre-wrap' }}
                      >
                        {selectedAnnounce.content}
                      </p>
                    </div>
                  )} */}
                </div>
              </div>

              {/* Create new announcement */}
              <div className="card mb-4 shadow-sm">
                <div className="card-header font-weight-bold">
                  Create Announcement
                </div>
                <div className="card-body m-4">
                  <Form onSubmit={handleCreate}>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm={2} className="label-bold">
                        Description
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          size="sm"
                          placeholder="Announcement content"
                          value={content}
                          onChange={(e) => setContent(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                    <Row>
                      <Col sm={{ span: 8, offset: 2 }}>
                        <Button
                          type="submit"
                          variant="primary"
                          size="sm"
                          disabled={isLoadingCreatingAnnounce}
                        >
                          {isLoadingCreatingAnnounce
                            ? 'Saving...'
                            : 'Save Announcement'}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </Row>
        <Modal show={showConfirm} onHide={handleClose}>
          <Modal.Body className="modal_same_confirmation">
            <h1>Delete</h1>
            Are you sure want to delete?
            <div className="buttons-container">
              <button
                className="custom_yes_button"
                onClick={(e) => handleYes(e)}
                style={{ backgroundColor: '#33ac68' }}
              >
                Yes
              </button>
              <button
                className="custom_no_button"
                onClick={handleClose}
                style={{ backgroundColor: '#cf5353' }}
              >
                No
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default AnnouncePage;
